'use client';
var UNARY_BREAKPOINT_FUNCTIONS = [
    "up",
    "down",
    "not",
    "only"
];
var parseBasicQuery = function(query) {
    var _query_split = query.split("."), size = _query_split[0], fn = _query_split[1];
    return {
        isValid: size && fn && UNARY_BREAKPOINT_FUNCTIONS.includes(fn),
        size: size,
        fn: fn
    };
};

export { parseBasicQuery };
